var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 397.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.89 41.28v240.28h238.58c-3.66-13.38-4.39-27.21-2.41-40.61H90.71c-3.66 0-6.62-2.96-6.62-6.62s2.96-6.63 6.62-6.63h41.89v-99.19c0-1.54 1.25-2.79 2.79-2.79h21.15c1.54 0 2.79 1.25 2.79 2.79v99.19h29.87v-69.61c0-1.54 1.25-2.79 2.79-2.79h21.15c1.53 0 2.79 1.26 2.79 2.79v69.61h29.87V98.92c0-1.54 1.25-2.79 2.79-2.79h21.15c1.52 0 2.79 1.27 2.79 2.79V227.7h19.42a99.897 99.897 0 0 1 10.45-23.81v-66.93c0-1.54 1.24-2.79 2.78-2.79h21.16c1.53 0 2.78 1.26 2.78 2.79v37.93a99.654 99.654 0 0 1 20.15-11.25c11.71-4.86 24.54-7.54 37.97-7.54 3.21 0 6.4.16 9.57.46V41.28H52.89zm246.57 260.49H234.7v34.91l48.21 45.84-13.9 14.6-34.31-32.63v26.2h-20.21V364.5l-34.32 32.62-13.89-14.6 48.21-45.84v-34.91H0v-20.21h32.68V41.28H.44V21.07h214.05V0h20.21v21.07h214.04v20.21h-31.72v119.39a99.14 99.14 0 0 1 40.41 24.51c25.75 25.75 35.32 63.71 24.96 98.57a98.764 98.764 0 0 1-10.09 22.82l38.45 41.9a4.766 4.766 0 0 1-.28 6.72l-28.23 25.78c-1.93 1.76-4.93 1.63-6.69-.3l-36.78-40.45c-15.58 9.49-33.29 14.43-51.53 14.43-26.37 0-51.56-10.43-70.2-29.08a99.505 99.505 0 0 1-17.58-23.8zm143.79-102.41c-22.61-22.6-56.88-29.4-86.32-17.21-52.83 21.88-64.97 90.01-25.72 129.23 22.65 22.6 56.84 29.42 86.32 17.22 29.64-12.31 48.91-41.14 48.91-73.23 0-10.75-2.13-20.99-5.98-30.29a79.644 79.644 0 0 0-17.21-25.72z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphic);
export default __webpack_public_path__ + "static/media/graphic.229fb6ce.svg";
export { ForwardRef as ReactComponent };